import './Text.css';



export function AdmittedStudentsDay() {
  return (
<div class="body">

<div class="row" >
          <img src="ASD2.gif" alt="">
</img>
        </div>

<div class="row" id="GalleryThree">

  <div class="column">   
                      <h2>Admitted Students Day</h2>
                      <h4>
            Client: Minneapolis College of Art and Design
            <br/>
            Project Length: 8 Months
            <br/><br/><br/><hr/><br/>
<h2>Deliverables:</h2>
            Mailers, Invitations, and Thank you card.
            <br/>Lunch Bag and Sticker Design, and Wayfinding Signage.
            <br/>Instagram Feed Post and Story. e-mail & website gifs.
            <br/><br/><br/><hr/><br/>
<h2>Program Description:</h2>
<br/>
Admitted Student Day is Almost Here!
<br/><br/>
Join us for Admitted Student Day and experience what it’s like to be part of MCAD’s creative community.  Dive into life at MCAD through lively, interactive presentations covering academics, financial aid, student life, and wellness resources. 
<br/><br/>Customize your experience with choice-based workshops, guided campus tours, and one-on-one Q&A sessions with faculty, staff, and current students. Enjoy lunch, connect with our creative community, and leave with resources to prepare for your first semester, plus some MCAD swag.
<br/><br/>Plan to spend the day discovering everything MCAD has to offer!           <br/><br/>

                </h4>
  </div>


    <div class="column">   
<img src="ASD13.png" alt="">
 </img>

  </div>

      <div class="column">   
<img src="ASD14.jpg" alt="">
 </img>
  </div>
</div>


<div class="row" >
        <img src="ASD18.jpg"></img>

        </div>



 <div class="row" id="GalleryTwo">

    <div class="column">

                            <h2>My Creative Director’s expired sardine
can turned into a photo shoot for
digital collage. </h2>
                      <h4>
Pulling from my own first-year
experience at college, I experimented
with 4 design directions that
resonated with an eager, curious, and
experimental audience.<br/><br/>
With guidance from my Creative
Director, the iterations evolved into an
explosive, dreamy and playful narrative
about starting life at the Minneapolis
College of Art and Design.<br/><br/>

While she encouraged me run
after my big dreams, she also wrangled
my tendency to run awry. She taught
me how to tame the beast that I had
already caught.
            </h4>

      </div>

          <video  autoplay controls loop >
            <source  src="ASD3.mp4" type="video/mp4"/>
          </video>
 <img src="ASD11.jpg" alt="">
 </img>
 <img src="ASD12.jpg" alt="">
 </img>
        </div>






<div class="row">


    <div class="column"> 
  <img src="ASD19.jpg" alt="">
 </img>


</div></div>





<div class="row" >

        <img src="ASD7.jpg" alt="">
        </img>

</div>



        <div class="row" id="GalleryTwo">

    <div class="column">
        <img src="ASD9.jpg" alt="">
        </img>
    </div>


    <div class="column">                
      <img src="ASD8.jpg" alt="">
        </img>
    </div>

        <div class="column">
        <img src="ASD5.jpg" alt="">
        </img>
    </div>

        <div class="column">
        <img src="ASD6.jpg" alt="">
        </img>
    </div>

    </div>


<div class="row" >
        <img src="ASD1.jpg" alt="">
        </img>
        <img src="ASD10.jpg" alt="">
        </img>

</div>
        

<div class="row">
<div class="column">
        <img  src="ASD25.jpg"></img>  
</div>
<div class="column">
        <img  src="ASD24.jpg"></img>
  </div>
<div class="column">
        <img  src="ASD23.jpg"></img>
</div>
<div class="column">
        <img  src="ASD22.jpg"></img>
</div>
<div class="column">
        <img  src="ASD21.jpg"></img>
</div>
<div class="column">
        <img  src="ASD20.jpg"></img>
</div>

        </div>

</div>

  );
}
